import { cn } from "../lib/utils";

type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Adds default padding
 */
export const Container = ({
  ref,
  className,
  ...props
}: ContainerProps & { ref?: React.Ref<HTMLDivElement> }) => {
  return (
    <div
      {...props}
      ref={ref}
      className={cn("h-full overflow-scroll overscroll-contain p-4", className)}
    />
  );
};

Container.displayName = "Container";
